import React, { useState, useEffect } from 'react';

const THEMES = ['light', 'dark', 'system'];
const THEME_LABELS = { light: 'Light', dark: 'Dark', system: 'System' };
const THEME_ICONS = { light: 'bi-sun', dark: 'bi-moon-stars', system: 'bi-circle-half' };

const getInitialTheme = () => {
  try {
    const saved = localStorage.getItem('injee-theme');
    if (saved && THEMES.includes(saved)) {
      return saved;
    }
  } catch {
    // ignore
  }
  return 'system';
};

const applyTheme = (theme) => {
  const root = document.documentElement;
  if (theme === 'system') {
    const dark = window.matchMedia('(prefers-color-scheme: dark)').matches;
    root.setAttribute('data-theme', dark ? 'dark' : 'light');
  } else {
    root.setAttribute('data-theme', theme);
  }
};

const Navbar = ({ activeView, onViewChange, joystick }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [theme, setTheme] = useState(getInitialTheme);

  useEffect(() => {
    applyTheme(theme);
    if (theme === 'system') {
      const mq = window.matchMedia('(prefers-color-scheme: dark)');
      const handler = () => applyTheme('system');
      mq.addEventListener('change', handler);
      return () => mq.removeEventListener('change', handler);
    }
  }, [theme]);

  const cycleTheme = () => {
    const next = THEMES[(THEMES.indexOf(theme) + 1) % THEMES.length];
    setTheme(next);
    try {
      localStorage.setItem('injee-theme', next);
    } catch {
      // ignore
    }
  };

  const delayChanged = joystick.activeDelay != null && joystick.activeDelay !== 0;
  const statusChanged = joystick.activeStatus != null && joystick.activeStatus !== 200;

  let blinkClass = "";

  if (delayChanged && !statusChanged) {
    blinkClass = "blink-yellow";
  } else if (!delayChanged && statusChanged) {
    blinkClass = "blink-blue";
  } else if (delayChanged && statusChanged) {
    blinkClass = "blink-green";
  }

  return (
    <nav className="navbar" role="navigation" aria-label="main navigation" style={{ borderBottom: '1px solid var(--bulma-border)' }}>
      <div className="navbar-brand">
        <div className="navbar-item">
          <img
            src="https://injee.codeberg.page/img/injee.webp"
            alt="Injee Logo"
            style={{ height: '32px', marginRight: '12px' }}
          />
          <span className="title is-4" style={{ margin: 0 }}>
            Injee Admin
          </span>
        </div>

        <button
          className={`navbar-burger burger ${isOpen ? 'is-active' : ''}`}
          aria-label="menu"
          aria-expanded={isOpen}
          onClick={() => setIsOpen(!isOpen)}
          style={{ background: 'none', border: 'none', cursor: 'pointer' }}
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </button>
      </div>

      <div className={`navbar-menu ${isOpen ? 'is-active' : ''}`}>
        <div className="navbar-start">
          <a
            href="#!"
            className={`navbar-item ${activeView === 'tables' ? 'is-active' : ''}`}
            onClick={() => {
              onViewChange('tables');
              setIsOpen(false);
            }}
            style={{
              cursor: 'pointer',
              backgroundColor: activeView === 'tables' ? '#2d5a27' : 'transparent',
              color: activeView === 'tables' ? 'white' : undefined,
              display: 'flex',
              alignItems: 'center',
              gap: '6px'
            }}
          >
            Tables <i className="bi bi-table" style={{ fontSize: "18px" }} />
          </a>
          <a
            href="#!"
            className={`navbar-item ${activeView === 'joystick' ? 'is-active' : ''}`}
            onClick={() => {
              onViewChange('joystick');
              setIsOpen(false);
            }}
            style={{
              cursor: 'pointer',
              backgroundColor: activeView === 'joystick' ? '#2d5a27' : 'transparent',
              color: activeView === 'joystick' ? 'white' : undefined,
              display: 'flex',
              alignItems: 'center',
              gap: '6px'
            }}
          >
            Joystick <i className={`bi bi-joystick ${blinkClass}`} style={{ fontSize: "18px" }} />
          </a>

          <a
            href="#!"
            className={`navbar-item ${activeView === 'operations' ? 'is-active' : ''}`}
            onClick={() => {
              onViewChange('operations');
              setIsOpen(false);
            }}
            style={{
              cursor: 'pointer',
              backgroundColor: activeView === 'operations' ? '#2d5a27' : 'transparent',
              color: activeView === 'operations' ? 'white' : undefined,
              display: 'flex',
              alignItems: 'center',
              gap: '6px'
            }}
          >
            Operations <i className="bi bi-gear-wide-connected" style={{ fontSize: "18px" }} />
          </a>
        </div>

        <div className="navbar-end">
          <div className="navbar-item">
            <button
              type="button"
              className="button is-small"
              onClick={cycleTheme}
              title={`Theme: ${THEME_LABELS[theme]}`}
              style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
            >
              <i className={`bi ${THEME_ICONS[theme]}`} style={{ fontSize: '16px' }} />
              <span>{THEME_LABELS[theme]}</span>
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;